import React from 'react'

import ReactWhatsapp from "react-whatsapp";


import genjifrock from "../images/GENJI FROCK 1-2.jpg";
import genjifrockyellow from "../images/GENJI FROCK 2-1.jpg";
import genjifrock2_2 from "../images/GENJI FROCK 2-2.jpg";
import genjifrocklight from "../images/GENJI FROCK 3-1.jpg";

import genjifrock2set from "../images/GENJI FROCK3-2.jpg"
import SARARASET from "../images/SARARA SET.jpg";
import shortfrock from "../images/SHORT FOCK 1.jpg";
import shortfrock2 from "../images/SHORT FOCK 2.jpg"

import shortfrockyellow from "../images/SHORT FOCK 3.jpg";
import shortfrockpink from "../images/SHORT FOCK 4.jpg";
import shortfrockred from "../images/SHORT FOCK 5.jpg";
import shortfrockpinkcolor from "../images/SHORT FOCK 6.jpg";

import shortfrockgreenwhite from "../images/SHORT FOCK 7.jpg";
import Skritset from "../images/SKIRT SET 1-1.jpg";
import Skritset2 from "../images/SKIRT SET 1-2.jpg";



import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'






function KidsFrock() {
    return (
        <div>

          
            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={genjifrock} className="card-img-top" alt="genjifrock"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Genji Frock </h5>
                                                <p className="card-text">3 Set</p>
                                              

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <ReactWhatsapp number="++91 9832223839" className="bethuadahari" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={genjifrockyellow} className="card-img-top" alt="genjifrockyellow"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Genji Frock  </h5>
                                                <p className="card-text">Yellow color</p>
                                             
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <ReactWhatsapp number="++91 9832223839" className="bethuadahari" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={genjifrock2_2} className="card-img-top" alt="genjifrock2_2"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">genjifrock</h5>
                                                <p className="card-text">2 Set</p>
                                          
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <ReactWhatsapp number="++91 9832223839" className="bethuadahari" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={genjifrocklight} className="card-img-top" alt="genjifrocklight"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Genji Frock                             </h5>
                                                <p className="card-text">Light Yellow color</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <ReactWhatsapp number="++91 9832223839" className="bethuadahari" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

    <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={genjifrock2set} className="card-img-top" alt="genjifrock2set"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Genji Frock </h5>
                                                <p className="card-text">2 Set</p>
                                              

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <ReactWhatsapp number="++91 9832223839" className="bethuadahari" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={SARARASET} className="card-img-top" alt="SARARASET"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">SARARA SET  </h5>
                                                <p className="card-text">Yellow color</p>
                                             
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <ReactWhatsapp number="++91 9832223839" className="bethuadahari" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={shortfrock} className="card-img-top" alt="shortfrock"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Short Frock</h5>
                                                <p className="card-text">Light color</p>
                                          
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <ReactWhatsapp number="++91 9832223839" className="bethuadahari" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={shortfrock2} className="card-img-top" alt="shortfrock2"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Short Frock                             </h5>
                                                <p className="card-text">Blue Pink color</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <ReactWhatsapp number="++91 9832223839" className="bethuadahari" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            
    <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={shortfrockyellow} className="card-img-top" alt="shortfrockyellow"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Short Frock </h5>
                                                <p className="card-text">Yellow color</p>
                                              

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <ReactWhatsapp number="++91 9832223839" className="bethuadahari" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={shortfrockpink} className="card-img-top" alt="shortfrockpink"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Short Frock  </h5>
                                                <p className="card-text">Pink color</p>
                                             
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <ReactWhatsapp number="++91 9832223839" className="bethuadahari" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={shortfrockred} className="card-img-top" alt="shortfrock"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Short Frock</h5>
                                                <p className="card-text">Pink color</p>
                                          
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <ReactWhatsapp number="++91 9832223839" className="bethuadahari" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={shortfrockpinkcolor} className="card-img-top" alt="shortfrockpinkcolor"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Short Frock                             </h5>
                                                <p className="card-text"> Pink color</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <ReactWhatsapp number="++91 9832223839" className="bethuadahari" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

                    
    <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={shortfrockgreenwhite} className="card-img-top" alt="shortfrockgreenwhite"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Short Frock </h5>
                                                <p className="card-text">Green & White color</p>
                                              

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <ReactWhatsapp number="++91 9832223839" className="bethuadahari" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={Skritset} className="card-img-top" alt="Skritset"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Skrit Set  </h5>
                                                <p className="card-text">White & Green color</p>
                                             
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <ReactWhatsapp number="++91 9832223839" className="bethuadahari" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={Skritset2} className="card-img-top" alt="Skritset2"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Skritset2</h5>
                                                <p className="card-text">White & Green / Pink color</p>
                                          
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <ReactWhatsapp number="++91 9832223839" className="bethuadahari" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <br />

            <br />
        </div>
    )
}

export default KidsFrock